import React, { useState, useEffect } from 'react'
import { Input, Button, Alert, Space, Typography, message } from 'antd'
import { SaveOutlined } from '@ant-design/icons'
import { useI18n } from '@/shared/i18n'
import { useForbiddenWords, useUpdateForbiddenWords } from '@/shared/api/forbiddenWordsApi'

const { Text } = Typography

const ForbiddenWords: React.FC = () => {
  const { t } = useI18n('modules')
  const { data, isLoading } = useForbiddenWords()
  const updateMutation = useUpdateForbiddenWords()
  const [text, setText] = useState('')

  useEffect(() => {
    if (data?.forbidden_words) {
      setText(data.forbidden_words.join('\n'))
    }
  }, [data])

  const handleSave = () => {
    const words = text
      .split('\n')
      .map(w => w.trim())
      .filter(Boolean)

    const unique = [...new Set(words)]

    updateMutation.mutate(unique, {
      onSuccess: () => {
        message.success(t('agentConfig.forbiddenWords.saveSuccess'))
      },
      onError: () => {
        message.error(t('agentConfig.forbiddenWords.saveFailed'))
      },
    })
  }

  const wordCount = text.split('\n').filter(l => l.trim()).length

  return (
    <div style={{ maxWidth: 720 }}>
      <Alert
        type="info"
        showIcon
        message={t('agentConfig.forbiddenWords.tip')}
        style={{ marginBottom: 16 }}
      />
      <Space direction="vertical" style={{ width: '100%' }} size="middle">
        <Input.TextArea
          value={text}
          onChange={e => setText(e.target.value)}
          placeholder={t('agentConfig.forbiddenWords.placeholder')}
          autoSize={{ minRows: 12, maxRows: 30 }}
          disabled={isLoading}
        />
        <Space style={{ justifyContent: 'space-between', width: '100%' }}>
          <Text type="secondary">
            {t('agentConfig.forbiddenWords.count', { count: wordCount })}
          </Text>
          <Button
            type="primary"
            icon={<SaveOutlined />}
            onClick={handleSave}
            loading={updateMutation.isPending}
          >
            {t('common.save')}
          </Button>
        </Space>
      </Space>
    </div>
  )
}

export default ForbiddenWords
